import { IUnit } from "../../types/recipe";
import { getApi } from "../api";
import { UnitDb } from "../indexeddb/unitDb";
import { getStringFromLocalStorage } from "../localStorage";

const apiUrl = import.meta.env.VITE_API_URL as string;
const apiToken = getStringFromLocalStorage("idToken");

export class UnitStore {
  private static instance: UnitStore | null = null;
  private _readyPromise: Promise<void>;
  private db = new UnitDb();
  public units: IUnit[] = [];
  private constructor() {
    this._readyPromise = this.load();
  }

  public static getInstance(): UnitStore {
    if (!UnitStore.instance) {
      UnitStore.instance = new UnitStore();
    }
    return UnitStore.instance;
  }

  public ready(): Promise<void> {
    return this._readyPromise;
  }

  private async load(): Promise<void> {
    await this.db.initDB();
    await this.getUnits();
  }

  public async getUnits(clear: boolean = false): Promise<void> {
    try {
      const local = await this.db.getUnits();
      if (local.length === 0 || clear) {
        const api = await getApi(apiUrl, "unit", apiToken);
        await this.db.addUnits(api, clear);
        this.units = api;
      } else {
        this.units = local;
      }
    } catch (e: any) {
      console.log(e);
    }
  }
}
